export default __webpack_public_path__ + "static/media/logo.c556c5be.jpg";